import { AccountBalance } from "@hashgraph/sdk";
import { HashConnectTypes } from "hashconnect";
import {
  MaintainanceData,
  SaveData,
  TransactionType,
  WalletExtensionType,
  WithdrawStatus,
} from "types/common";
import {
  SET_SAVE_DATA,
  SET_TVL,
  SET_INSTALLED_EXTENSION,
  SET_IS_EXTENSION_INSTALLED,
  SET_ACCOUNT_BALANCE,
  SET_SELECTED_ACCOUNT,
  SET_TRANSACTION_TYPE,
  SET_STATUS,
  SET_TRANSACTION_STATUS,
  SET_WITHDRAW_STATUS,
  SET_WITHDRAW_ID,
  SET_CONTRACT_TYPE,
  SET_TRANSACTION_ID,
  SET_CONNECTED_ACCOUNT_TYPE,
  SET_BLADE_EXTENSION_INSTALLED,
  SET_SHOW_WALLET_MODAL,
  SET_FIRESTORE_DATA,
  SET_DEFI_DATA,
  SET_UNDER_MAINTENANCE_DATA,
} from "./constants";

const action = {
  setSaveData: (saveData: SaveData) => {
    return {
      type: SET_SAVE_DATA,
      payload: {
        saveData,
      },
    };
  },

  setTVL: (tvl: number) => {
    return {
      type: SET_TVL,
      payload: {
        tvl,
      },
    };
  },
  setInstalledExtensions: (
    installedExtensions: HashConnectTypes.WalletMetadata | null
  ) => {
    return {
      type: SET_INSTALLED_EXTENSION,
      payload: {
        installedExtensions,
      },
    };
  },
  setIsExtensionInstalled: (isExtensionInstalled: boolean) => {
    return {
      type: SET_IS_EXTENSION_INSTALLED,
      payload: {
        isExtensionInstalled,
      },
    };
  },
  setAccountBalance: (accountBalance: AccountBalance | null) => {
    return {
      type: SET_ACCOUNT_BALANCE,
      payload: {
        accountBalance,
      },
    };
  },
  setSelectedAccount: (selectedAccount: string) => {
    return {
      type: SET_SELECTED_ACCOUNT,
      payload: {
        selectedAccount,
      },
    };
  },
  setTransactionType: (transactionType: TransactionType) => {
    return {
      type: SET_TRANSACTION_TYPE,
      payload: {
        transactionType,
      },
    };
  },
  setStatus: (status: string) => {
    return {
      type: SET_STATUS,
      payload: {
        status,
      },
    };
  },
  setTransactionStatus: (transactionStatus: string) => {
    return {
      type: SET_TRANSACTION_STATUS,
      payload: {
        transactionStatus,
      },
    };
  },
  setWithdrawStatus: (withdrawStatus: WithdrawStatus) => {
    return {
      type: SET_WITHDRAW_STATUS,
      payload: {
        withdrawStatus,
      },
    };
  },
  setWithdrawId: (withdrawId: number | null) => {
    return {
      type: SET_WITHDRAW_ID,
      payload: {
        withdrawId,
      },
    };
  },
  setContractType: (contractType: string | null) => {
    return {
      type: SET_CONTRACT_TYPE,
      payload: {
        contractType,
      },
    };
  },
  setTransactionId: (transactionId: string | null) => {
    return {
      type: SET_TRANSACTION_ID,
      payload: {
        transactionId,
      },
    };
  },
  setConnectedAccountType: (connectedAccountType: WalletExtensionType) => {
    return {
      type: SET_CONNECTED_ACCOUNT_TYPE,
      payload: {
        connectedAccountType,
      },
    };
  },
  setBladeExtensionInstalled: (isBladeExtensionInstalled: boolean) => {
    return {
      type: SET_BLADE_EXTENSION_INSTALLED,
      payload: {
        isBladeExtensionInstalled,
      },
    };
  },
  showWalletModal: (walletModal: boolean) => {
    return {
      type: SET_SHOW_WALLET_MODAL,
      payload: {
        walletModal,
      },
    };
  },
  setFireStoreData: (firestoreData: Object) => {
    return {
      type: SET_FIRESTORE_DATA,
      payload: {
        firestoreData,
      },
    };
  },
  setDefiData: (defiData: Object) => {
    return {
      type: SET_DEFI_DATA,
      payload: {
        defiData,
      },
    };
  },
  setMaintainanceData: (maintainanceData: MaintainanceData) => {
    return {
      type: SET_UNDER_MAINTENANCE_DATA,
      payload: {
        ...maintainanceData,
      },
    };
  },
};

export default action;
